<template>

<div class="text-wrapper" :class="{'is-fixed': fixed}">

	<button class="text-x" v-if="fixed" v-on:click="$emit('close')"><span>X</span></button>

	<div class="text" ref="text" v-html="text"></div>

	<button class="text-close" v-if="fixed" v-on:click="$emit('close')"><span>Close</span></button>

	<com-info :block="block" :info="info" :modal="true" :auto="true" v-if="info" v-on:close="info = false" />

</div>

</template>

<script>

import comInfo from '@/components/tool/common/section/form/Info'

export default {

	props: ['text', 'fixed'],

	components: {
		'com-info': comInfo
	},

	data: function() {

		return {
			block: false,
			info: false,
			links: []
		}

	},

	created: function() {

		if (this.fixed) this.$pubsub.$emit('overlay')

		this.$nextTick(function() {

			this.$_.each(this.$refs.text.getElementsByTagName('a'), function(link) {

				if (link.getAttribute('data-link-type') === '1' || link.getAttribute('data-link-type') === '5') {

					this.links.push(link)

				} 

				link.addEventListener('click', this.onLinkClick.bind(this))

			}.bind(this))

		}.bind(this))

	},

	beforeDestroy: function() {

		if (this.fixed) this.$pubsub.$emit('overlay')

		this.$_.each(this.links, function(link) {

			link.removeEventListener('click', this.onLinkClick.bind(this))

		}.bind(this))	

	},

	methods: {

		onLinkClick: function(e) {

			e.stopPropagation()
			
			if (e.srcElement.getAttribute('data-link-type').toString() === '1') {

				e.preventDefault()
				this.block = false
				this.info = parseInt(e.srcElement.getAttribute('data-link-page'))

			} else if (e.srcElement.getAttribute('data-link-type').toString() === '5') {

				e.preventDefault()
				this.block = true
				this.info = parseInt(e.srcElement.getAttribute('data-link-page'))

			}

		}

	}

}

</script>

<style scoped>

.text-wrapper.is-fixed {
	position: fixed;
	top: 0px;
	right: 0px;
	left: 0px;
	width: 100%;
	overflow-y: scroll;
	overflow-x: hidden;
	padding: 48px 16px 16px 16px;
	bottom: 0px;
	background-color: #fff;
	z-index: 100;
}

.text >>> a {
	font-weight: bold;
}

.text >>> a:hover {
	text-decoration: underline;
}

.text >>> p {
	font-size: 16px;
	line-height: 24px;
	font-weight: 100;
	margin-bottom: 16px;
	color: #343434;
}

.is-mobile .text >>> p {
	font-size: 14px;
	line-height: 18px;
}

.text >>> b,
.text >>> strong {
	font-weight: 700;
}

.text >>> ul {
	list-style: disc;
	list-style-position: outside;
	margin-bottom: 16px;
}

.text >>> ul ul {
	margin-left: 32px;
	list-style: revert;
}

.text >>> ol {
	list-style: decimal;
	list-style-position: outside;
	margin-bottom: 16px;
}

.text >>> ul li {
	font-size: 16px;
	line-height: 24px;
	font-weight: 100;
	color: #343434;
	margin-left: 24px;
}

.is-mobile .text >>> ul li {
	font-size: 14px;
	line-height: 18px;
	margin-left: 16px;
}

.text >>> *:last-child {
	margin-bottom: 0px;
}

.text-close {
	margin: 0px 10px;
	min-width: 150px;
	padding: 0px 20px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid #4cebb0;
	font-size: 18px;
	font-weight: 700;
	color: #343434;
	margin-left: 20px;
	transition: all 300ms ease-in-out;
}

.is-tablet .text-close {
	margin-top: 16px;
}

.is-mobile .text-close {
	width: 100%;
	margin: 0px 0px 10px 0px;
	min-height: 32px;
	line-height: 18px;
	font-size: 14px;
	padding: 0px 10px;
	border-radius: 16px;
	margin-top: 32px;
}

.text-close:hover {
	background-color: #4cebb0;
	color: #fff;
}

.text-x {
	position: fixed;
	right: 0px;
	top: 0px;
	width: 40px;
	height: 40px;
	line-height: 40px;
	background-color: #fff;
	z-index: 1001;
	text-align: center;
	font-size: 32px;
}

</style>